/* unplugin-vue-components disabled */import { render } from "./releaseNotes.vue?vue&type=template&id=261fd656&scoped=true"
import script from "./releaseNotes.vue?vue&type=script&lang=js"
export * from "./releaseNotes.vue?vue&type=script&lang=js"

import "./releaseNotes.vue?vue&type=style&index=0&id=261fd656&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-261fd656"]])

export default __exports__